import React, { useState } from "react";
import PopupWindow from "hooks/usePopupWindow";
import LanguagesList from "./LanguagesList";

const LanguagesContainer = () => {
    const [languagesList, setLanguagesList] = useState(false);

    return (
        <li className="accessories-item">
            <PopupWindow theSet={setLanguagesList}>
                <button
                    className={`header-btn languages-btn ${languagesList ? 'active': ''}`}
                    onClick={() => {
                        setLanguagesList(!languagesList);
                    }}
                >
                    <span>
                        <ion-icon name="globe"></ion-icon>
                    </span>
                </button>
                {languagesList && <LanguagesList setLanguagesList={setLanguagesList} />}
            </PopupWindow>
        </li>
    );
};

export default LanguagesContainer;
